import { openModal } from "@mantine/modals";
import { getImageUrl } from "common/utils/getImageUrl";
import { Photo } from "tabler-icons-react";
import { useState } from "react";

function MessageImage({
  imageKey,
  imageKeyApproved,
}: {
  imageKey?: string;
  imageKeyApproved?: boolean;
}) {
  const [imageError, setImageError] = useState(false);

  if (!imageKey) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "200px",
          backgroundColor: "#f0f0f0",
          borderRadius: "4px",
          border: imageKeyApproved === false ? "2px solid red" : "none",
        }}
      >
        <Photo size={48} color="#ccc" />
      </div>
    );
  }

  const openImageModal = () => {
    if (imageError) return; // Don't open modal if image failed

    openModal({
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={getImageUrl(imageKey)}
            alt="Non trouvée"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
          />
        </div>
      ),
      size: "auto",
      withCloseButton: false,
    });
  };

  if (imageError) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "200px",
          backgroundColor: "#f0f0f0",
          borderRadius: "4px",
          border:
            imageKeyApproved === false ? "2px solid red" : "1px solid #ddd",
        }}
      >
        <Photo size={48} color="#999" />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <img
        src={getImageUrl(imageKey)}
        alt="Non trouvée"
        onClick={openImageModal}
        onError={() => setImageError(true)}
        className="cursor-pointer"
        style={{
          width: "100%",
          maxHeight: "200px",
          objectFit: "contain",
          borderRadius: "4px",
          border: imageKeyApproved === false ? "2px solid red" : "none",
          cursor: "pointer",
        }}
      />
    </div>
  );
}

export default MessageImage;
